import { DataLayer } from '@piwikpro/react-piwik-pro';
import React from 'react';

import { Link } from 'gatsby';

import { GlobalStyles, Grid2 as Grid, styled } from '@mui/material';

import { ConversionButton, ResponsiveGrid, StickyHeader } from '@mewa/ui';

import t from '../../../libs/translate';
import {
  BaseNavigation,
  HeaderBaseProps,
  HeaderWrapper,
  MewaLogo,
  wrapperStyles,
} from './header-base';

type CampaignHeaderProps = {
  headerText?: string;
  ctaLabel: string;
  ctaUrl: string;
  piwikEventName: string | null | undefined;
};

export const CampaignHeader = ({
  langPrefix,
  navigationData,
  piwikEventNameForHeaderCTAButton,
  showCTA = true,
  headerText,
  ctaLabel,
  ctaUrl,
  piwikEventName,
}: HeaderBaseProps & CampaignHeaderProps) => {
  const trackConversion = piwikEventNameForHeaderCTAButton
    ? () => {
        DataLayer.push({ event: piwikEventNameForHeaderCTAButton });
      }
    : undefined;

  const showDefaultConversionLink = !ctaLabel && !ctaUrl;

  return (
    <>
      <GlobalStyles
        styles={{
          ':root': {
            '@media (max-width: 717px)': {
              '--header-height': '64px !important',
            },
          },
        }}
      />
      <StickyHeader>
        <ResponsiveGrid
          sx={wrapperStyles}
          gridProps={{ sx: { height: '100%' } }}
        >
          <Grid size={12}>
            <HeaderWrapper>
              <MewaLogo langPrefix={langPrefix} />

              <BaseNavigation>
                {!showDefaultConversionLink && (
                  <>
                    {headerText ? (
                      <CampaignContactButtonLabel>
                        {headerText}
                      </CampaignContactButtonLabel>
                    ) : null}
                    <ConversionButton
                      variant="contained"
                      link={{
                        component: Link,
                        props: {
                          to: ctaUrl,
                          target: '_blank',
                        },
                      }}
                      sx={{
                        marginTop: 0,
                        display: { xs: 'block' },
                        marginRight: { md: 2 },
                        alignSelf: 'center',
                        width: 'auto',
                      }}
                      onClick={() => {
                        if (piwikEventName) {
                          DataLayer.push({
                            event: piwikEventName,
                          });
                        }
                      }}
                    >
                      {ctaLabel}
                    </ConversionButton>
                  </>
                )}
                {showCTA && showDefaultConversionLink ? (
                  <>
                    <CampaignContactButtonLabel>
                      {t(
                        navigationData.headerAndFooterTranslations,
                        'campaign_header_consultation_label',
                      )}
                    </CampaignContactButtonLabel>
                    <ConversionButton
                      variant="contained"
                      link={{
                        component: Link,
                        props: {
                          to: `${langPrefix}/${navigationData.navigationLinks.conversion.contact.slug}`,
                        },
                      }}
                      sx={{
                        marginTop: 0,
                        display: { xs: 'block' },
                        marginRight: { md: 2 },
                        alignSelf: 'center',
                        width: 'auto',
                      }}
                      onClick={trackConversion}
                    >
                      {t(
                        navigationData.headerAndFooterTranslations,
                        'campaign_consultation_cta',
                      )}
                    </ConversionButton>
                  </>
                ) : null}
              </BaseNavigation>
            </HeaderWrapper>
          </Grid>
        </ResponsiveGrid>
      </StickyHeader>
    </>
  );
};

const CampaignContactButtonLabel = styled('p')(({ theme }) => ({
  ...theme.typography.body,

  margin: '0 38px 0 0',
  alignSelf: 'center',

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
